import {
  CounterpartyQueryFilters,
  CounterpartySortColumns,
  CounterpartyType,
  SortOrder
} from 'openapi';

import { INITIAL_PAGINATION_PROPS } from './paginations';

export type CounterpartyMultiFilterFieldName =
  | 'names'
  | 'registrationNumbers'
  | 'vatNumbers'
  | 'expenseTypes';

export type CounterpartySingleFilterFieldName = 'type' | 'approved';

export type CounterpartyFilterFieldNames =
  | CounterpartyMultiFilterFieldName
  | CounterpartySingleFilterFieldName;

export interface CounterpartyMultiSelectFilterField {
  kind: 'multi';
  name: CounterpartyMultiFilterFieldName;
  translationKey: string;
}

export interface CounterpartySingleSelectFilterOption {
  value: string | boolean;
  translationKey: string;
}

export interface CounterpartySingleSelectFilterField {
  kind: 'single';
  name: CounterpartySingleFilterFieldName;
  translationKey: string;
  options: CounterpartySingleSelectFilterOption[];
}

export type CounterpartyFilterField =
  | CounterpartyMultiSelectFilterField
  | CounterpartySingleSelectFilterField;

export interface CounterpartyFilterFormValues {
  names: string[];
  registrationNumbers: string[];
  vatNumbers: string[];
  expenseTypes: string[];
  type: CounterpartyType | null;
  approved: boolean | null;
}

export const INITIAL_COUNTERPARTY_FILTERS: CounterpartyQueryFilters = {
  pageSize: INITIAL_PAGINATION_PROPS.pageSize,
  pageNumber: INITIAL_PAGINATION_PROPS.page,
  sortBy: CounterpartySortColumns.NAME,
  sortOrder: SortOrder.ASC
};

export const FILTER_FIELDS: CounterpartyMultiSelectFilterField[] = [
  {
    kind: 'multi',
    name: 'names',
    translationKey: 'labels.name'
  },
  {
    kind: 'multi',
    name: 'registrationNumbers',
    translationKey: 'labels.companyRegistrationNumber'
  },
  {
    kind: 'multi',
    name: 'vatNumbers',
    translationKey: 'labels.vatNumber'
  }
];

export const COMPANY_FILTER_FIELDS: CounterpartyFilterField[] = [
  ...FILTER_FIELDS,
  {
    kind: 'multi',
    name: 'expenseTypes',
    translationKey: 'labels.expenseType'
  },
  {
    kind: 'single',
    name: 'approved',
    translationKey: 'labels.approved',
    options: [
      { value: true, translationKey: 'labels.approved' },
      { value: false, translationKey: 'labels.notApproved' }
    ]
  },
  {
    kind: 'single',
    name: 'type',
    translationKey: 'labels.type',
    options: [
      { value: CounterpartyType.SUPPLIER, translationKey: 'labels.company' },
      {
        value: CounterpartyType.REIMBURSEMENT,
        translationKey: 'labels.reimbursement'
      }
    ]
  }
];

export const FILTERS_VALUES = {
  names: [],
  registrationNumbers: [],
  vatNumbers: []
};

export const COMPANIES_FILTERS_DEFAULT_VALUES: CounterpartyFilterFormValues = {
  ...FILTERS_VALUES,
  expenseTypes: [],
  type: null,
  approved: null
};
